import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import ScheduleDemoModal from './ScheduleDemoModal';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'For Colleges', href: '/' },
    { name: 'For Mentors', href: '/for-mentors' },
    { name: 'Learn', href: '/learn' },
    { name: 'About Founder', href: '/about-founder' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_edu-social-design/artifacts/zll423im_Edusocial%20logo.jpg" 
              alt="EduSocial Logo" 
              className="h-12 w-auto object-contain"
            />
            <div className="hidden lg:block px-3 py-1 text-xs font-semibold rounded-full" style={{backgroundColor: '#e8f5ee', color: '#012726'}}>
              CENTRE OF EXCELLENCE
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="text-gray-700 font-medium transition-colors duration-200"
                style={{'--hover-color': '#012726'}}
                onMouseEnter={(e) => e.target.style.color = '#012726'}
                onMouseLeave={(e) => e.target.style.color = ''}
              >
                {link.name}
              </Link>
            ))}
            <Button 
              className="text-white px-6 transition-all duration-200 hover:shadow-lg"
              style={{backgroundColor: '#33c375'}}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2ab066'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#33c375'}
              onClick={() => setShowDemoModal(true)}
            >
              Schedule Demo
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            onMouseEnter={(e) => e.target.style.color = '#012726'}
            onMouseLeave={(e) => e.target.style.color = ''}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-700 font-medium transition-colors duration-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                  onMouseEnter={(e) => e.target.style.color = '#012726'}
                  onMouseLeave={(e) => e.target.style.color = ''}
                >
                  {link.name}
                </Link>
              ))}
              <Button 
                className="text-white w-full transition-all duration-200"
                style={{backgroundColor: '#33c375'}}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2ab066'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#33c375'}
                onClick={() => {
                  setShowDemoModal(true);
                  setIsMobileMenuOpen(false);
                }}
              >
                Schedule Demo
              </Button>
            </nav>
          </div>
        )}
      </div>
      
      <ScheduleDemoModal open={showDemoModal} onOpenChange={setShowDemoModal} />
    </header>
  );
};

export default Header;
